import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-tooltip',
  templateUrl: 'ui-tooltip.component.html',
  styleUrls: ['ui-tooltip.component.scss'],
  standalone: false
})
export class UITooltipComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() title: string;
  @Input() content: string;
  @Input() icon: string;
  @Input() color: 'grey' | 'yellow' | 'blue' = 'grey';
}
